<template>
    <div class="rcclAlert" :style="show()" v-if="isShow">
        <div id="popup_overlay"></div>
        <div id="popup_container">
            <div id="popup_title">
                <div class="title_logo">
                  <img src="https://resource.rcclchina.com.cn/logo/PC/logoPopup.png" alt="">
                </div>
            </div>
            <div id="popup_content" class="alert">
                <div id="popup_message" style="max-height: 828px; overflow-y: scroll;" v-html="text"></div>
                <div id="popup_panel">
                    <a id="popup_ok" @click="confirmClick()">{{button}}</a>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'RcclAlert',
    data () {
        return  {
            title: '温馨提示',
            text: '',
            button: '确定',
            isShow: false
        }
    },
    props: {
        confirmCallBack: {
            type: Function
        }
    },
    methods: {
        confirmClick () {
            this.isShow = false
            if (this.confirmCallBack) {
                this.confirmCallBack()
            }
        },
        show() {
            return this.isShow ? { 'display': 'block'} : { 'display': 'none' }
        }
    }
}
</script>

<style lang="less" scoped>
    #popup_overlay {
        position: fixed;
        z-index: 99998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgb(102, 102, 102);
        opacity: 0.5;
    }
    #popup_container {
        position: fixed;
        z-index: 99999;
        padding: 0;
        margin: 0;
        min-width: 380px;
        max-width: 380px;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
</style>
